import apiClient from "./apiClient";

export const login = async (username, password) => {
  const res = await apiClient.post("/auth/login", { username, password });
  return res.data;
};

export const getCurrentUserAccess = async () => {
  const res = await apiClient.get("/auth/me/access", { skipAuthRedirect: true });
  return res.data;
};

